import {booleanAttribute, ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {BeslutningIndeksfelter, DokumentType, ElasticSearchTreff, EntitetType, IndeksertEntitet, OppgaveIndeksfelter, OpplastetDokumentVersjonIndeksfelter, SakIndeksfelter} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {EntitetikonKomponent} from "web-ng2/delt/komponenter/entitetikon/entitetikon";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {TranslateModule} from "@ngx-translate/core";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {entitetTypeFraTreff} from "felles-ng2/modell/indekssøkeresultatModellHjelpere";
import {StrengMalPipe} from "felles-ng2/pipes/StrengMalPipe";
import {standardStreng} from "felles-ng2/støttefunksjoner/strenger";
import {Klokke} from "felles-ng2/tjenester/Klokke";
import {MillisSidenEpochSomZonedDateTime} from "felles-ng2/pipes/millisSidenEpochSomZonedDateTime";

const debug = initDebugger('SøkVisTreffKomponent');

/**
 * Viser ett søketreff
 */
@Component({
    selector: 'soek-vis-treff',
    templateUrl: 'søk-vis-treff.html',
    styleUrl: 'søk-vis-treff.scss',
    imports: [
        EntitetikonKomponent,
        FormaterPlainDatePipe,
        TranslateModule,
        ZonedDateTimeSomPlainDatePipe,
        StrengMalPipe,
        MillisSidenEpochSomZonedDateTime
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SøkVisTreffKomponent {

    treff = input.required<ElasticSearchTreff<any>>();
    visTekstmatch = input(true, {transform: booleanAttribute});

    indeksertEntitet = computed(() => this.treff()._type);
    entitetType = computed(() => entitetTypeFraTreff(this.treff()));

    somSak = computed(() => this.treff()._source as SakIndeksfelter);
    somDokument = computed(() => this.treff()._source as OpplastetDokumentVersjonIndeksfelter);
    erArkivdokumentTreff = computed(() => this.indeksertEntitet() == IndeksertEntitet.opplastetDokumentVersjon && this.somDokument().dokforeldertype == DokumentType.arkivdokument);
    somBeslutning = computed(() => this.treff()._source as BeslutningIndeksfelter);
    somOppgave = computed(() => this.treff()._source as OppgaveIndeksfelter);
    erOppgaveTreff = computed(() => this.indeksertEntitet() == IndeksertEntitet.oppgave);
    oppgaveansvarlig = computed(() => this.erOppgaveTreff() ? standardStreng(this.somOppgave().ansvarlig, this.oversettelser.oversett(i18n('ingen'))) : '');

    readonly entitetTyper = EntitetType;
    readonly indekserteEntiteter = IndeksertEntitet;

    constructor(private oversettelser: Oversettelser, private klokke: Klokke) {
    }

    tekstmatchFraTreff(felt: string): string {
        if (!this.treff().highlight[felt]) return '';
        return this.treff().highlight[felt]
          .reduce((samlet, match) => `${samlet} (...) ${match}`)
    }

    // private hjelpemetoder

}

